/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CellValueUnion = core.serialization.undiscriminatedUnion([
    core.serialization.string(),
    core.serialization.number(),
    core.serialization.number(),
    core.serialization.number(),
    core.serialization.boolean(),
    core.serialization.string(),
    core.serialization.date(),
    core.serialization.list(core.serialization.string()),
]);
